import styled from 'styled-components'

export const Description = styled.div`
  color: #757575;
  font-weight: 700;
  font-size: 14px;
`

export const BackFooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

export const BackFooterButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f0f0f0;
  border: none;
  color: #4c4c4c;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  border-radius: 8px;
  height: auto;
  padding: 12px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    background: #f0f0f0;
    color: rgba(76, 76, 76, 0.7);
    border: none;
    box-shadow: none;
  }
  &:focus,
  &:active {
    background: #f0f0f0;
    color: #4c4c4c;
    border: none;
    outline: none;
    box-shadow: none;
  }
`
